import { useQuery } from '@apollo/react-hooks'
import {
  // Alert,
  // AlertDescription,
  // AlertIcon,
  Box,
  Select,
  // Button,
  Flex,
  Heading,
  Image,
  // Icon,
  Link,
  Text,
  Button,
} from '@chakra-ui/react'
import {
  Link as ReachLink,
  // Router,
  useLocation,
} from '@reach/router'
import { gql } from 'apollo-boost'
import React from 'react'
// import Assets from './components/Assets'
import ImpermanentLossCalculator from './components/ImpermanentLossCalculator'
// import Pools from './components/Pools'
import { GiAtom } from 'react-icons/gi'
import ColorModeSwitcher from './components/ColorModeSwitcher'

const App = (props) => {
  const location = useLocation()

  return (
    <>
      <Flex
        justifyContent="space-between"
        alignItems="center"
        px={6}
        py={3}
        borderBottomWidth={1}
      >
        <a href="https://mechanaut.xyz">
          <Flex justifyContent="space-between" alignItems="center">
            <GiAtom />
            <Heading ml={1} size="md">
              Mechanaut
            </Heading>
          </Flex>
        </a>
        <ColorModeSwitcher justifySelf="flex-end" />
      </Flex>
      <Flex alignItems="center" justifyContent="space-between" w={{ md: '800px' }} mr={{base: 6, md: 'none'}} ml={6} my={6}>
        <Box>
          <Flex alignItems="center" mb={1}>
            <Box mr={1} w={30}>
              <Image src={require('./images/baller logo.png')} />
            </Box>
            <Heading fontWeight="bolder" size="lg" letterSpacing={-1}>
              $BALLER
            </Heading>
          </Flex>
          <Text display={{base: 'none', md: 'inline-block'}}>Impermanent Loss Simulator for Balancer Pools</Text>
        </Box>
      </Flex>
      <Box>
        <ImpermanentLossCalculator />
        {/* <Box width={800}>
          <Box mx={6} borderWidth={1} rounded="lg">
            <Flex
              align="center"
              justify="space-between"
              p={6}
              borderBottomWidth={1}
            >
              <Flex align="center">
                <ReachLink to="/">
                  <Text fontWeight={location.pathname === '/' && 'bold'} mr={6}>
                    Pools
                  </Text>
                </ReachLink>
                <ReachLink to="/assets">
                  <Text fontWeight={location.pathname === '/assets' && 'bold'}>
                    Assets
                  </Text>
                </ReachLink>
              </Flex>
              <Button
                size="sm"
                as={Link}
                _hover={{ textDecoration: 'none' }}
                href="https://pools.balancer.exchange/#/pool/new"
              >
                Create pool
              </Button>
            </Flex>
            <Router primary={false}>
              <Pools default path="/" data={data} loading={loading} />
              <Assets path="/assets" data={data} loading={loading} />
            </Router>
          </Box>
        </Box> */}
      </Box>
      <Flex
        my={6}
        borderTopWidth={1}
        px={6}
        py={3}
        alignItems="center"
        justifyContent="space-between"
      >
        <Text mr={6}>
          Made by{' '}
          <Link
            textDecoration="underline"
            href="https://twitter.com/tannedoaksprout"
          >
            oaksprout
          </Link>{' '}
          in support of{' '}
          <Link href="https://balancer.finance" textDecoration="underline">
            Balancer
          </Link>
        </Text>
        <a href="https://mechanaut.xyz">
          <Flex alignItems="center">
            <GiAtom />
            <Heading ml={1} size="md">
              Mechanaut
            </Heading>
          </Flex>
        </a>
      </Flex>
    </>
  )
}

export default App
